import { Action, getModule, Module, Mutation, VuexModule } from 'vuex-module-decorators';
import { store } from '@/store/store';

import { getConfig } from '@/config';
import { hubClient } from '@tfpl/api-client';

export const categories = ['ONE_ON_ONE', 'SALARY_RAISE', 'YEAR_GOALS', 'OTHER'];

@Module({ name: 'User1on1sModule', store, dynamic: true, namespaced: true })
export class User1on1sModule extends VuexModule {
  /**************************************************************************
   * STATE
   *************************************************************************/
  private _loading = false;
  private _error = false;
  private _user1on1s: hubClient.Collaborator1On1Dto[] = [];
  private _onlyFinancialMessages: boolean = false;

  /**************************************************************************
   * GETTERS
   *************************************************************************/
  get user1on1s(): hubClient.Collaborator1On1Dto[] {
    return this._user1on1s;
  }

  get loading(): boolean {
    return this._loading;
  }

  get error(): boolean {
    return this._error;
  }

  get onlyFinancialMessages(): boolean {
    return this._onlyFinancialMessages;
  }

  /**************************************************************************
   * MUTATIONS
   *************************************************************************/
  @Mutation
  setUser1on1s(user1on1s: hubClient.Collaborator1On1Dto[]): void {
    this._user1on1s = user1on1s;
  }

  @Mutation
  clearData(): void {
    this._user1on1s = [];
  }

  @Mutation
  setLoading(loading: boolean): void {
    this._loading = loading;
  }

  @Mutation
  setError(error: boolean): void {
    this._error = error;
  }

  @Mutation
  setOnlyFinancialMessages(onlyFinancialMessages: boolean): void {
    this._onlyFinancialMessages = onlyFinancialMessages;
  }

  /**************************************************************************
   * ACTIONS
   *************************************************************************/
  @Action({ rawError: true })
  public async fetchUser1on1s({
    collaboratorUuid,
    dateFrom,
    dateTo,
  }: {
    collaboratorUuid: string;
    dateFrom?: string;
    dateTo?: string;
  }): Promise<void> {
    this.setLoading(true);
    this.clearData();

    try {
      const { data: response } = await hubClient.V3Collaborator1On1Service.getManyV3({
        path: { tenant: getConfig().TENANT, company: getConfig().TENANT },
        query: {
          limit: 999,
          offset: 0,
          collaboratorUuid,
          onlyFinancialMessages: this.onlyFinancialMessages,
          dateFrom,
          dateTo,
        },
        throwOnError: true,
      });
      this.setUser1on1s(response.data);
    } catch (err) {
      this.setError(true);
      console.log(err);
    } finally {
      this.setLoading(false);
    }
  }
  @Action({ rawError: true })
  public async fetchMy1on1s(): Promise<void> {
    this.setLoading(true);
    this.clearData();

    try {
      const { data: response } = await hubClient.V3Collaborator1On1Service.getManyForMeV3({
        path: { tenant: getConfig().TENANT, company: getConfig().TENANT },
        query: {
          limit: 999,
          offset: 0,
          onlyFinancialMessages: this.onlyFinancialMessages,
        },
        throwOnError: true,
      });
      this.setUser1on1s(response.data);
    } catch (err) {
      this.setError(true);
      console.log(err);
    } finally {
      this.setLoading(false);
    }
  }
}
export default getModule(User1on1sModule);
